<template>
  <v-data-table :headers="head" :items="Trans" :loading="load">
    <template v-slot:top>
      <v-toolbar flat color="grey lighten-4">
        <v-toolbar-title>{{ Title }}</v-toolbar-title>

        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <div class="flex-grow-1"></div> -->

        <v-spacer></v-spacer>
        <div>
          <cashDisplay :isloading="load" :Balance="TotalCash"></cashDisplay>
        </div>
      </v-toolbar>
    </template>
    <template v-slot:[`item.deposit`]="{ item }">
      <slot name="deposit" :row="item">
        <template v-if="item.Acc == 'Dr'">
          {{ Math.abs(item.Amount).toLocaleString() }}
          <strong>{{ item.AmountType | MoneySigns }}</strong>
        </template>
      </slot>
    </template>
    <template v-slot:[`item.withdraw`]="{ item }">
      <slot name="withdraw" :row="item">
        <template v-if="item.Acc == 'Cr'">
          {{ Math.abs(item.Amount).toLocaleString() }}
          <strong>{{ item.AmountType | MoneySigns }}</strong>
        </template>
      </slot>
    </template>
    <template #[`item.del`]="{item}">
      <!-- {{ item }} -->
      <BaseDelete
        :OnFinish="Onfinish"
        :DelQuery="{ Ref: item.Ref }"
        DelUrl="stock/Ontheway/transactions"
      >
        <template #title> DELETE {{ item.Description }} TRAN.. </template>
        <!-- {{ item }} -->
        <v-row>
          <v-col>{{ item.Reason }}</v-col>
          <v-col>{{ item.Account }}</v-col>
          <v-col>{{ item.Details }}</v-col>
          <v-col>{{ item.Amount }}</v-col>
        </v-row>
      </BaseDelete>
    </template>
  </v-data-table>
</template>
<script>
// import cashDisplay from "@/components/displayCash.vue";
export default {
  components: {
    cashDisplay: () => import("@/components/util/displayCash.vue"),
  },
  props: {
    Onfinish: { type: Function, required: true },
    Trans: { type: Array, required: true },
    TotalCash: { type: Array, required: true },
    load: { type: Boolean, default: false },
    Title: { type: String, default: "" },
    head: {
      type: Array,
      default: () => [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        // { text: "Account", value: "Account" },
        { text: "Description", value: "Description" },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Del", value: "del" },
      ],
    },
  },
};
</script>
